import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { UserData } from "Data/interfaces";
import { Spinner } from "react-bootstrap";

interface DeleteModalProps {
  data: UserData | null;
  loading: boolean;
  handleDeleteModalClose: () => void;
  onDelete: (id: number) => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  handleDeleteModalClose,
  data,
  onDelete,
  loading,
}) => {
  return (
    <div>
      <ModalContainer handleClose={handleDeleteModalClose} dropShadow={false}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 black-text">Confirm Delete</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleDeleteModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div>
            {loading ? (
              <div className="d-flex justify-content-center p-2">
                <Spinner animation="border" variant="dark" />
              </div>
            ) : (
              <p className="text-black">Do you want to Delete? </p>
            )}

            <div className="d-flex justify-content-center align-items-center">
              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-dark"
                role="button"
                onClick={handleDeleteModalClose}
              >
                <span className={`mx-2 d-flex`}>Cancel</span>
              </div>

              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-danger"
                role="button"
                onClick={() => {
                  onDelete(data?.id ?? 0);
                }}
              >
                <span className={`mx-2 d-flex text-white`}>Delete Account</span>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DeleteModal;
